<template>
  <div class="flex" v-if="authStore.hasRole(P2Role.ADMIN)" id="payment-actions">
    <div
      v-if="authStore.hasPermissions([CustomPermissions.viewPaymentInfo]) && !editPaymentInfo"
      class="mr-3 flex align-items-center"
    >
      <ShowInfo />
    </div>
    <template v-if="showActions">
      <Validate v-if="editPaymentInfo" />
      <EditActions />
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { CustomPermissions, P2Role } from '@centric-os/types';
import { useFinancialConfigStore } from '../../../../../routes';
import ShowInfo from './show-info/ShowInfo.vue';
import EditActions from './edit-actions/EditActions.vue';
import Validate from './validate/Validate.vue';
import { computed, provide, toRef } from 'vue';
import { usePaymentInfo } from '../composables';
import { useFieldValue } from 'vee-validate';
import { paymentInfoContextKey } from '../context';

const props = defineProps({
  isSiteConfig: {
    type: Boolean,
    default: true,
  },
  isCentricHub: {
    type: Boolean,
    default: false,
  },
});

// Actions render in PagePanel header, outside PaymentInfo — provide context for child action components
provide(paymentInfoContextKey, {
  // @ts-expect-error FIXME: Type 'Ref<boolean>' is not assignable to type 'ComputedRef<boolean>'.
  isCentricHub: toRef(props, 'isCentricHub'),
});

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

// Set auth store
const authStore = useAuthStore();

const { hasPaymentConfig } = usePaymentInfo({ isCentricHub: toRef(props, 'isCentricHub') });

const typeFieldName = computed(() => {
  return isStationInitialSetup.value ? 'paymentConfig.paymentSettings.type' : 'type';
});

// Set payment config type field value
const type = useFieldValue<string>(typeFieldName.value);

const showActions = computed(() => {
  return !isStationInitialSetup.value || hasPaymentConfig.value || type.value;
});
</script>
